import { NavLink } from 'react-router-dom';

export default function PublicNavigation() {
  return <nav className="af-public-navigation" aria-label="Main navigation">
    {[['/', 'Fundraising Strategy Review'], ['/funding-audience-review', 'Identify Ideal Funders'], ['/build-a-business', 'Build a Business'], ['/about-rooney', 'About Rooney']].map(([path, label]) => <NavLink key={path} to={path} end={path === '/'}>{label}</NavLink>)}
  </nav>;
}
